export default __webpack_public_path__ + "static/media/next-audio-4.3ddd703c.mp3";